import gql from 'graphql-tag';

export const schema = gql`
  query GetPublicationFeatures($publicationId: String!) {
    getPropertyListingPublication(id: $publicationId) {
      __typename
      ... on GetPropertyListingPublicationSuccess {
        publication {
          id
          complementaryAreas: attribute(key: "amenities/complementary_areas") {
            complementaryAreas {
              balcony
              storageRoom
              patio
              terrace
            }
          }
          security: attribute(key: "amenities/security") {
            security {
              alarm
              cctv
              securityDoor
            }
          }
          interiorFeatures: attribute(key: "amenities/interior_features") {
            interiorFeatures {
              heating
              fireplace
              serviceRoom
              studyLibrary
              gasInstallation
              jacuzzi
            }
          }
          exteriorCharacteristics: attribute(
            key: "amenities/exterior_characteristics"
          ) {
            exteriorCharacteristics {
              elevator
              basketballCourt
              soccerField
              squashCourt
              tennisCourt
              gym
              pool
              communalRoom
              sauna
              bbqArea
              childrenArea
              greenAreas
            }
          }
        }
      }

      ... on GetPropertyListingPublicationFailure {
        error {
          code
          message
          metadata {
            key
            value
          }
        }
      }
    }
  }
`;
